import type { CountryCode } from '~/core/i18n'
import { COPYRIGHT_IDENTIFIER, COUNTRY_CODE, LOGO, LOGO_MONO, MF_URL, MT_VRACH_URL, PD_URL } from '~/core/i18n'

export const useAppLocale = defineStore('appLocale', () => {
  const isCis = ref(useRuntimeConfig().public.isCis === 'true')

  const isRu = computed(() => !isCis.value)

  const currentCountry = ref<CountryCode>(COUNTRY_CODE.RU)

  const pdName = computed(() => isRu.value ? 'ПроДокторов' : 'YDoc')

  const pdUrl = computed(
    () => PD_URL[currentCountry.value] || PD_URL[COUNTRY_CODE.RU],
  )
  const mfUrl = computed(
    () => MF_URL[currentCountry.value] || `https://medflex.me/${currentCountry.value}/`,
  )
  const mtVrachUrl = computed(
    () => MT_VRACH_URL[currentCountry.value] || MT_VRACH_URL[COUNTRY_CODE.RU],
  )

  const copyright = computed(() => {
    const text = `© 2011–${new Date().getFullYear()} МедРокет`

    const copyrightIdentifier = COPYRIGHT_IDENTIFIER[currentCountry.value]

    if (!copyrightIdentifier) {
      return text
    }

    return `${text} ${copyrightIdentifier}`
  })

  const logo = computed(
    () => LOGO[currentCountry.value] || LOGO[COUNTRY_CODE.RU],
  )

  const logoMono = computed(
    () => LOGO_MONO[currentCountry.value] || LOGO_MONO[COUNTRY_CODE.RU],
  )

  return {
    isCis,
    isRu,
    currentCountry,
    pdName,
    pdUrl,
    mfUrl,
    mtVrachUrl,
    copyright,
    logo,
    logoMono,
  }
})
